import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map } from 'immutable';
import classNames from 'classnames';

import { Spinner } from '../../../helpers/Spinner';

import style from './style.module.css';

/**
 * Side menu component.
 *
 * @param props {Object}.
 * @param props.approvals {Immutable.List} List of approval.
 * @param props.common {Immutable.Map} Common data.
 * @param props.onSelect {String} Handle event of clicking on a menu item.
 * @param {boolean} props.isNoApproval No approval list selected state.
 * @class
 */
const MenuComponent = ({ approvals, common, onSelect, isNoApproval }) => {
  const approval = common.get('approval');
  const loading = common.get('appListLoading');
  const noApproval = common.get('noApproval');
  const id = approval.get('id');
  const spinner = loading ? <Spinner className="bg-white" /> : null;

  const renderNoApprovalItem = noApproval.size > 0 && (
    <li>
      <a
        className={classNames(style.link, { [style.active]: isNoApproval })}
        href="#"
        onClick={() => onSelect('no_approval_lists')}
        role="button"
        tabIndex={0}
      >
        (No Approval List)
      </a>
    </li>
  );

  const content = !loading ? (
    <ul className={style.list}>
      {approvals.map(approval => (
        <li key={approval.get('id')}>
          <a
            className={classNames(style.link, { [style.active]: approval.get('id') === id })}
            onClick={() => onSelect(approval.get('id'))}
          >
            {approval.get('label')}
          </a>
        </li>
      ))}
      {renderNoApprovalItem}
    </ul>
  ) : null;

  return (
    <div className={style.host}>
      {spinner}
      {content}
    </div>
  );
};

MenuComponent.propTypes = {
  approvals: PropTypes.instanceOf(List).isRequired,
  common: PropTypes.instanceOf(Map).isRequired,
  isNoApproval: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

/** Menu component. */
export const Menu = memo(MenuComponent);
